const LISTA_AUSILI_LIBERA = {
	bologna: [
		"Cuscino antidecubito",
		"Materasso o traverse antidecubito",
		"Tavolo inclinabile per statica",
		"Ausili per evacuazione (sedia comoda con o senza ruote, rialzo wc, sgabello wc)",
		"Ausili per lavarsi, per fare il bagno e la doccia (sedia girevole per vasca, sedia da doccia)",
		"Ausili per la deambulazione (deambulatore, girello, stampella, tripode)",
		"Tricicli a pedale o a propulsione con le mani",
		"Carrozzina manuale",
		"Carrozzina a motore elettrico",
		"Scooter elettrico",
		"Unità di propulsione elettrificata per carrozzina (triride, propulsore,moltiplicatore di spinta con joystick)",
		"Passeggino",
		"Ausili per il trasferimento (asse,disco girevole, telo ad alto scorrimento)",
		"Ausili per il sollevamento (sollevatore con imbracatura)",
		"Ausili per la postura seduta (seggiolone, bascula)",
		"Letto manuale",
		"Letto elettrico",
		"Sponde di contenimento",
		"Asta solleva- persona (supporto per alzarsi)",
		"Montascale mobile",
		"Rampe portatili",
		"Ausili per la comunicazione o sistemi di controllo a distanza (comunicatori)",
	],
	torino: [
		"Cuscino antidecubito",
		"Materasso o traverse antidecubito",
		"Tavolo inclinabile per statica",
		"Ausili per evacuazione (sedia comoda con o senza ruote, rialzo wc, sgabello wc)",
		"Ausili per lavarsi, per fare il bagno e la doccia (sedia girevole per vasca, sedia da doccia)",
		"Ausili per la deambulazione (deambulatore, girello, stampella, tripode)",
		"Tricicli a pedale o a propulsione con le mani",
		"Carrozzina manuale",
		"Carrozzina a motore elettrico",
		"Scooter elettrico",
		"Unità di propulsione elettrificata per carrozzina (triride, propulsore,moltiplicatore di spinta con joystick)",
		"Passeggino",
		"Ausili per il trasferimento (asse,disco girevole, telo ad alto scorrimento)",
		"Ausili per il sollevamento (sollevatore con imbracatura)",
		"Ausili per la postura seduta (seggiolone, bascula)",
		"Letto manuale",
		"Letto elettrico",
		"Sponde di contenimento",
		"Asta solleva- persona (supporto per alzarsi)",
		"Montascale mobile",
		"Rampe portatili",
		"Ausili per la comunicazione o sistemi di controllo a distanza (comunicatori)",
	],
	romagna: [
		"Cuscino antidecubito",
		"Materasso o traverse antidecubito",
		"Tavolo inclinabile per statica",
		"Ausili per evacuazione (sedia comoda con o senza ruote, rialzo wc, sgabello wc)",
		"Ausili per lavarsi, per fare il bagno e la doccia (sedia girevole per vasca, sedia da doccia)",
		"Ausili per la deambulazione (deambulatore, girello, stampella, tripode)",
		"Tricicli a pedale o a propulsione con le mani",
		"Carrozzina manuale",
		"Carrozzina a motore elettrico",
		"Scooter elettrico",
		"Unità di propulsione elettrificata per carrozzina (triride, propulsore,moltiplicatore di spinta con joystick)",
		"Passeggino",
		"Ausili per il trasferimento (asse,disco girevole, telo ad alto scorrimento)",
		"Ausili per il sollevamento (sollevatore con imbracatura)",
		"Ausili per la postura seduta (seggiolone, bascula)",
		"Letto manuale",
		"Letto elettrico",
		"Sponde di contenimento",
		"Asta solleva- persona (supporto per alzarsi)",
		"Montascale mobile",
		"Rampe portatili",
		"Ausili per la comunicazione o sistemi di controllo a distanza (comunicatori)",
	],
};

export default LISTA_AUSILI_LIBERA;
